module.exports = __webpack_public_path__ + "static/img/banner-3.78c5ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/banner-3.png
// module id = 8CAJ
// module chunks = 10